const collapsibleTriggers = document.querySelectorAll(
  "[data-collapsible-trigger]",
);

collapsibleTriggers.forEach((trigger) => {
  trigger.addEventListener("click", (e) => {
    e.preventDefault();

    trigger
      .closest("[data-collapsible-container]")
      .querySelectorAll("[data-collapsible-section]")
      .forEach((section) => {
        section.classList.toggle("hidden");
        const caret = trigger.querySelector(".caret");
        if (!caret) return;

        caret.classList.toggle("-rotate-90");
        caret.classList.toggle("rotate-90");
      });
  });
});
